import styled from 'styled-components';
import { C } from '../../theme/tokens';

export const TableContainer = styled.table<{ $hasIndex?: boolean }>`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid ${C.gray1};
  overflow: auto;
  thead {
    background: ${C.gray0};
    border-bottom: 1px solid ${C.gray1};
    position: sticky;
    left: 0;
    top: -1px;
    z-index: 9;
    tr {
      th {
        ${({ $hasIndex }) =>
          $hasIndex &&
          `
        &:first-child {
          padding: 11px 5px;
          text-align: center;
          
        }
        `}
        border-right: 1px solid #F1F3F5;

        &:last-child {
          text-align: right;
        }

        .th-wrapper {
          width: 100%;
          justify-content: space-between;
          display: flex;
          align-items: center;
        }

        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        padding: 12px 8px;
        color: ${C.gray7};
      }
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid ${C.gray1};

      &:last-child {
        border-bottom: none;
      }

      /* Rows in this table are click targets on every page that uses it, but the hover rule had been
         commented out — hovered and idle rows were pixel-identical, so nothing told you which row a
         click would take. A neutral tint, since the accent colour means "selected". */
      transition: background-color 150ms ease;

      &:hover {
        background-color: ${C.gray0};
      }

      /* Ticking a row's checkbox changed nothing about the row — selection was legible only from the
         box itself, so a selected row and its neighbours looked identical while the toolbar counted
         them. Blue means selected, and it outranks the neutral hover. */
      &:has(input[type='checkbox']:checked) {
        background-color: ${C.blue0};
      }

      td {
        ${({ $hasIndex }) =>
          $hasIndex &&
          `
        &:first-child {
          background: ${C.gray2};
          width: 30px;
          padding: 8px;
          text-align: center;
          border-right: 1px solid #F1F3F5;
        }

		
      `}

        border-right: 1px solid #F1F3F5;
        font-size: 14px;
        line-height: 21px;
        padding: 8px;
      }
    }
  }
`;
